import React, { useEffect, useState } from 'react';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { BRAND, NAV, WHATSAPP_LINK } from '../data/mock';
import MagneticButton from './MagneticButton';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
          scrolled
            ? 'bg-[#0A0B0E]/70 backdrop-blur-xl border-b border-white/5 py-3'
            : 'bg-transparent py-5'
        }`}
      >
        <div className="thesis-container flex items-center justify-between">
          {/* Logo */}
          <a href="/" data-testid="site-logo-link" className="flex items-end gap-1 group cursor-hover" translate="no">
            <span className="font-display text-[26px] leading-none tracking-[-0.06em] text-[#F5F1E8]">
              Thesis
            </span>
            <span className="font-serif-italic text-[#C8FF61] text-[22px] leading-none -mb-[2px] group-hover:rotate-180 transition-transform duration-700">
              °
            </span>
          </a>

          {/* Nav desktop */}
          <nav className="hidden md:flex items-center gap-9">
            {NAV.map((item) => (
              <a key={item.href} href={item.href} data-testid={`header-nav-${item.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-')}-link`}
                className="line-link text-[13px] font-medium tracking-wide text-[#F5F1E8]/85 hover:text-[#F5F1E8] transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden md:flex items-center gap-5">
            <span className="font-mono-label text-[#8E8B85]">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#C8FF61] mr-2 animate-pulse" />
              {BRAND.coords}
            </span>
            <MagneticButton
              href={WHATSAPP_LINK()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-whatsapp-link"
              className="cursor-hover"
              strength={0.25}
            >
              <span className="inline-flex items-center gap-2 bg-[#C8FF61] hover:bg-[#F5F1E8] text-[#0A0B0E] px-5 py-2.5 rounded-full text-[13px] font-semibold tracking-tight transition-colors duration-300">
                WhatsApp
                <ArrowUpRight size={14} strokeWidth={2.5} />
              </span>
            </MagneticButton>
          </div>

          {/* Mobile toggle */}
          <button className="md:hidden p-2 text-[#F5F1E8]" data-testid="mobile-menu-open-button"
            onClick={() => setOpen(true)} aria-label="Abrir menu">
            <Menu size={22} />
          </button>
        </div>
      </header>

      {/* Mobile menu */}
      <div className={`fixed inset-0 z-[60] bg-[#0A0B0E] transition-transform duration-500 md:hidden ${open ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="thesis-container flex items-center justify-between h-[72px]">
          <span className="font-display text-[26px] text-[#F5F1E8]" translate="no">Thesis<span className="font-serif-italic text-[#C8FF61]">°</span></span>
          <button onClick={() => setOpen(false)} data-testid="mobile-menu-close-button" className="p-2 text-[#F5F1E8]" aria-label="Fechar"><X size={22} /></button>
        </div>
        <div className="thesis-container mt-10 flex flex-col gap-6">
          {NAV.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setOpen(false)} data-testid={`mobile-nav-${item.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-')}-link`}
              className="font-display text-[44px] leading-none text-[#F5F1E8]">{item.label}</a>
          ))}
          <a
            href="/blog"
            onClick={() => setOpen(false)}
            data-testid="mobile-menu-featured-blog-link"
            className="mt-2 rounded-[8px] border border-[#D4AF37]/30 bg-[#D4AF37]/10 p-5 text-left cursor-hover"
          >
            <span className="font-mono-label text-[#D4AF37]">BLOG THESIS</span>
            <span className="mt-2 flex items-center justify-between font-display text-[30px] leading-none text-[#F5F1E8]">
              Guias de SEO e marketing <ArrowUpRight size={22} />
            </span>
          </a>
          <a href={WHATSAPP_LINK()} target="_blank" rel="noopener noreferrer" data-testid="mobile-whatsapp-link" className="btn-primary mt-8 self-start">
            Falar no WhatsApp <ArrowUpRight size={18} />
          </a>
        </div>
      </div>
    </>
  );
}
